import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { ConstantsService } from '@app/common/constants.service';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { AlertService } from '../services/alert.service';
import { TokenService } from '../services/token.service';
import { AppSessionService } from '../services/app-session.service';
import { Router, RouterModule } from '@angular/router';
import { LoginService } from '../services/login.service';
import { CommonService } from '../services/CommonService';
import { UtilityService } from '@app/common/utility.service';
import { Idle } from '@ng-idle/core';
import { CommonModule } from '@angular/common';
import { UserAuthService } from '@app/shared/services/user-auth.service';
import { MatIcon } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UserDto } from '@app/apiModules/userDto';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';

@Component({
  standalone: true,
  selector: 'top-navbar',
  templateUrl: './top-navbar.component.html',
  styleUrls: ['./top-navbar.component.scss'],
  imports:[RouterModule, CommonModule,MatTooltipModule]
})
export class TopNavbarComponent implements OnInit {
  loggedInUserEmail: string;
  profilePanelVisibility = 'none';
  applicationName: string = "";
  IsloggedInUserAdmin: boolean = false;
  constructor(@Inject(SESSION_STORAGE) private readonly storage: StorageService,
    private alertService: AlertService,
    private tokenService: TokenService,
    private readonly router: Router,
    private readonly constantsService: ConstantsService,
    private readonly commonService: CommonService,
    private readonly utilityService : UtilityService,
    private idle: Idle,
    public readonly userAuthService: UserAuthService,
    private readonly sessionService: AppSessionService,
    private readonly loginService: LoginService,
    private toastr: ToastrService,
    private dialog: MatDialog) {
     }


  ngOnInit() {
    this.loggedInUserEmail = this.storage.get("user_name");
    this.applicationName = this.constantsService.applicationName;
    //To check User is Admin or not
    this.commonService.checkLoggedUserIsAdmin().then(isAdmin => {
      this.IsloggedInUserAdmin = isAdmin;
    });
    this.utilityService.initiateIdleSubcription();
    this.idle.watch(); // Start watching for user inactivity.
  }

  logOut(): void {
    this.alertService.buildDialog().fire({
      title: "Please confirm!",
      text: "You will be logged out from all active sessions. Are you sure you want to logout?",
      showCancelButton: true,
      confirmButtonText: "Yes, Logout!",
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
      icon: this.alertService.WarningIcon,
    }).then((result) => {
      if (result.value) {
        this.tokenService.stopRefreshTokenTimer();
        this.profilePanelVisibility = 'none';
        this.signOut()
        this.dialog.closeAll();
      }
      else {
        this.profilePanelVisibility = 'none';
      }
    });
  }

  // this method will clear user session and redirect to login page 
  signOut() {
    this.loginService.apiUserLogoutPost()
      .subscribe({
      next: _result => {
        this.utilityService.setSessionLogoutContext('manual_logout');
        // remove browserSessionId from session storage
        this.utilityService.logoutFromSystem();
        this.router.navigate(['/']);
      },
      error: (err) => {
        this.toastr.error("Error while user logout", "error");
        console.error('Error while user logout', err);
        this.router.navigate(['/']);
      }
      });
  }
}
